// import { Api, auth } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import reg from '@/reg'
import * as _ from 'lodash';

// another vue
import groupList from '../../group/group.List.i18n'
// import logLoginList from '../../../Log/login/Login.List.Use'
import logLoginList from '../../../Log/login/login.User.List.i18n'
import logActionList from '../../../Log/action/action.User.List.i18n'

//restful api
import { auth } from '@/service'
import { user as manager } from '@/service/api/manager'

const default_model = () => ({
  is_verified: true, group : { service : "Basic" }, permissions: 'User', username : '', new_password : '', new_password_repeat : '',
});

export default {
  props: ['user_id'],
  components: {
    logActionList,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
  },
  watch : {
    '$route' (to, from) { console.log("from : ", from);  this.get(to.params); },
  },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    group_list: undefined,
    model : default_model(),
    old_username : '',
    allowed: false,

    // group info side
    chainGroup : false,
    syncGroup : false,
    loadGroup : false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    origin : { timezone : "", country : "", language : "" },

  }),
  computed: {
    border() { return !reg.email.test(this.model.username) || this.model.title == '' ? 'danger' : 'success'},
    TextLength() { return this.model.username.length > 0 ? true : false; },
    profile() { return auth.profile; }
  },
  methods: {
    async get() {
      this.model = default_model()
      if(!this.user_id) { return this.$toastr.e('incorrect target user') }
      // this.model.id = Number(this.user_id ? this.user_id : id);
      console.log('User.detail.summary.vue', 'load item', this.user_id);
      try{
        this.add = false;
        this.lock = true
        // let rs = await Api.Manager_Call('user', 'detail', { id : this.user_id })
        let rs = await manager.detailUser({ id : this.user_id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(r.value == this.model.group.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(r.value == this.model.group.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.group.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
    }
  },
  created() { console.log('User.Detail.Summary.vue', 'created'); },
  destroyed() { console.log('User.Detail.Summary.vue', 'destroyed'); },
  mounted() {
    console.log('User.Detail.Summary.vue', 'mounted');
    this.get();
  },
}